export default __webpack_public_path__ + "static/media/hht1_ep8_minisitcom_04.90e54411.png";